import { z } from 'zod';

const envSchema = z.object({
  // Required: base URL used by both the Axios instance and the better-auth client
  VITE_API_URL: z.string().url('VITE_API_URL must be a valid URL'),

  // Optional: Stripe publishable key (frontend-only)
  VITE_STRIPE_PUBLIC_KEY: z.string().optional(),

  // Optional: Stripe price IDs for plan selection
  VITE_STRIPE_PRICE_ID_PRO: z.string().optional(),
  VITE_STRIPE_PRICE_ID_ENTERPRISE: z.string().optional(),

  // Optional: Sentry error tracking
  VITE_SENTRY_DSN: z.string().optional(),

  // Optional: PostHog analytics
  VITE_POSTHOG_API_KEY: z.string().optional(),
  VITE_POSTHOG_HOST: z.string().url('VITE_POSTHOG_HOST must be a valid URL').optional(),

  // Optional: Unleash feature flags proxy
  VITE_UNLEASH_PROXY_URL: z.string().url('VITE_UNLEASH_PROXY_URL must be a valid URL').optional(),
  VITE_UNLEASH_CLIENT_KEY: z.string().optional(),

  // Optional: application name used as Unleash appName
  VITE_APP_NAME: z.string().optional(),

  // Optional: Headway changelog widget
  VITE_HEADWAY_ACCOUNT_ID: z.string().optional(),

  // Optional: email/password auth feature toggle
  VITE_EMAIL_PASSWORD_ENABLED: z.string().optional(),
});

const result = envSchema.safeParse(import.meta.env);

if (!result.success) {
  const fieldErrors = result.error.flatten().fieldErrors;
  const messages = Object.entries(fieldErrors)
    .map(([field, errors]) => `  ${field}: ${errors?.join(', ')}`)
    .join('\n');
  throw new Error(`Invalid environment variables:\n${messages}`);
}

export const env = result.data;
